uniform vec3 uColorBottom;  // アーチ付近の色（緑）
uniform vec3 uColorTop;     // レイの先端の色（青紫）
uniform float uIntensity;   // 0-1。GSAP でフェード
uniform float uTime;
uniform float uSeed;        // レイヤーごとに模様をずらす
uniform sampler2D uPerlinTexture;

varying vec2 vUv;

/*
 * 球面バンド（星空球の内側）に描くオーロラ。
 * vUv.x = バンドに沿った方位、vUv.y = 0:上端 → 1:下端（地平線側）。
 * うねるアーチの中心線から上方向にレイ（カーテンのひだ）が伸びる。
 */
void main()
{
    float u = vUv.x;
    float v = vUv.y;

    // 空を横切る大きなアーチ（サイン波＋ノイズでゆっくりうねる中心線）
    float archNoise = texture2D(uPerlinTexture, vec2(u * 0.7 + uTime * 0.01 + uSeed, 0.25)).r;
    float arch = 0.58
        + 0.14 * sin(u * 4.8 + uTime * 0.06 + uSeed * 6.2831)
        + 0.20 * (archNoise - 0.5);

    float dist = v - arch; // 正: アーチより下（地平線側）

    // アーチの下側はすぐ消え、上側へはレイが長く伸びる
    float below = exp(-pow(max(dist, 0.0) * 10.0, 2.0));
    float above = exp(-pow(max(-dist, 0.0) * 3.0, 1.3));
    float profile = min(below, above);

    // カーテンのひだ（方位方向の細かい縦筋、ゆっくり流れる）
    float pleats = texture2D(uPerlinTexture, vec2(u * 6.0 + uTime * 0.02 + uSeed, 0.6)).r;
    pleats = 0.3 + 0.7 * smoothstep(0.2, 0.8, pleats);

    // 大きな濃淡（オーロラの濃い所・薄い所）
    float band = texture2D(uPerlinTexture, vec2(u * 1.5 - uTime * 0.012 + uSeed, 0.4)).r;
    band = smoothstep(0.1, 0.75, band);

    // バンドの左右端をなだらかに消す
    float edgeFade = smoothstep(0.0, 0.12, u) * (1.0 - smoothstep(0.88, 1.0, u));

    float strength = profile * pleats * band * edgeFade;

    // アーチ付近は緑、レイの先（上）ほど青紫
    float colorMix = clamp(-dist * 2.2, 0.0, 1.0);
    vec3 color = mix(uColorBottom, uColorTop, colorMix);

    // 加算ブレンドなので色・アルファ両方に強度を掛ける
    gl_FragColor = vec4(color * strength * uIntensity, strength * uIntensity);
}
